/**
 * Whether a listing's shipping takes padding (stored as the handling cost). Only calculated
 * shipping does: a flat rate is an all-in price, and free or switched-off shipping has nothing
 * to pad. The server charges whatever handling is stored, so every place that saves shipping
 * stores 0 where this is false.
 */
import { CALCULATED } from './shippingConstants';
import { checkIfFreeShipping } from './genericHelpers';

/** For the listing's domesticParams (or the same keys from a form). */
export const domesticPaddingApplies = params =>
  params?.domesticCostType === CALCULATED && !checkIfFreeShipping(params?.isFreeShipping);

/** For the listing's internationalParams (or the same keys from a form). */
export const internationalPaddingApplies = params =>
  params?.internationalCostType === CALCULATED &&
  !checkIfFreeShipping(params?.isFreeInternationalShipping) &&
  !checkIfFreeShipping(params?.isInternationalShippingDisabled);
